<template>
    <template>
        <v-dialog v-model="show" max-width="500">
            <v-card>
                <v-card-title>Conferma cancellazione</v-card-title>
                <v-card-text>Sei sicuro di voler cancellare l'elemento <b>{{ litigation_number }}</b>?</v-card-text>
                <v-card-actions>
                <v-btn @click="show = false">Annulla</v-btn>
                <v-btn @click="confirmDelete">Conferma</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </template>

    <template>
        <!-- SNACKBAR FOR ON-DISPLAY MESSAGES -->
        <snackbarTemplate ref="snackbar" />
    </template> 

</template>
 

<script>
    import axios from 'axios';
    import snackbarTemplate from './Snackbar.vue'

    export default {
        name: 'confirmDeleteDialog',
        emits: ['delete-completed'],
        data() {
            return {
                show: false,
                litigation_id: null,
                litigation_number: null
            } 
        },
        methods: {
            confirmDelete() {
                console.log('Cancellazione in corso...');
                axios.delete(`/api/litigations/${this.litigation_id}/`)
                .then(response => {
                    console.log('Eliminazione completata: ', response);
                    this.show = false;
                    this.$nextTick(() => {
                        this.$refs.snackbar.snackbar_message = 'Elemento cancellato con successo';
                        this.$refs.snackbar.snackbar_style = 'success';
                        this.$refs.snackbar.show = true;
                    });
                })
                .catch(error => {
                    console.error(error);
                    this.show = false;
                    this.$refs.snackbar.snackbar_message = error.response.data.error;
                    this.$refs.snackbar.snackbar_style = 'error';
                    this.$refs.snackbar.show = true;
                })
                .finally(() => this.$emit('delete-completed')); 
            }
        },
        components: {
            snackbarTemplate
        },
    }
</script>